// Home.jsx
import React from 'react';
import Plan from "../templates/Plan";
import Reservation from "../templates/Reservation";
// import Flow from "../templates/Flow";
import Gallery from "../templates/Gallery";
import AboutUs from "../templates/AboutUs";
import Welcome from '../templates/Welcome';
import Header from "../Header";
import Footer from "../Footer";


const Home = () => (
  <>
    <div className="background-blur">
      <Header />
      <main className="flex-grow">
        <Welcome />
        <AboutUs />
        <Plan />
        <Reservation />
        {/* <Flow /> */}
        <Gallery />
      </main>
      <Footer />
    </div>    
  </>
);

export default Home;
